<template>
  <div class="trx-date d-flex align-items-center">
    <div class="trx-date__label teal-300">{{ $t('global.object.transactionDate') }}</div>
    <mc-date-picker
      class="trx-date__input ms-2"
      v-model="periodCom"
      :placeholder="$t('global.action.selectDate')"
      format="DD MMM YY"
      value-type="YYYY-MM-DD"
      :shortcuts="makeShortcuts"
      :draft="true"
      range-separator=" - "
      range
      :confirm="true"
      :confirm-text="$t('global.action.apply')"
      ref="periodePicker"
      :clearable="false"
      :disabled-date="disabledRange"
      @pick="pickDate"
    ></mc-date-picker>
  </div>
</template>
<script>
import McDatePicker from '@/components/McDatePicker'
import moment from 'moment'
import { Helper } from '@/mixin/helper'
export default {
  components: { McDatePicker },
  mixins: [Helper],
  props: {
    period: {
      type: Array,
      default: () => {
        return [moment().subtract(6, 'd').format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')]
      },
    },
  },
  emits: ['update:period'],
  data() {
    return {
      pastDate: moment().subtract(1, 'years'),
      futureEnd: moment().add(1, 'years'),
    }
  },
  computed: {
    periodCom: {
      set(newVal) {
        this.$emit('update:period', newVal)
      },
      get() {
        return this.period
      },
    },
    makeShortcuts() {
      return [
        { text: this.$t('global.time.today'), onClick: () => [new Date(), new Date()] },
        {
          text: this.$t('global.time.yesterday'),
          onClick: () => {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24)
            return [date, date]
          },
        },
        {
          text: this.$t('global.time.last7Days'),
          onClick: () => {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 168)
            return [date, new Date()]
          },
        },
        {
          text: this.$t('global.time.last30Days'),
          onClick: () => {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 720)
            return [date, new Date()]
          },
        },
        {
          text: this.$t('global.time.thisMonth'),
          onClick: () => {
            const date = new Date()
            date.setTime(date.getTime() - 3600 * 1000 * 24 * (date.getDate() - 1))
            return [date, new Date()]
          },
        },
        {
          text: this.$t('global.time.lastMonth'),
          onClick: () => {
            const awal = new Date()
            awal.setTime(awal.getTime() - 3600 * 1000 * 24 * awal.getDate())
            awal.setTime(awal.getTime() - 3600 * 1000 * 24 * (awal.getDate() - 1))

            const akhir = new Date()
            akhir.setTime(akhir.getTime() - 3600 * 1000 * 24 * akhir.getDate())

            return [awal, akhir]
          },
        },
      ].map((shortcut) => ({ ...shortcut, value: shortcut.onClick }))
    },
  },
  methods: {
    disabledRange(date) {
      return date <= this.pastDate || date >= this.futureEnd
    },
    pickDate(date) {
      let maxDate = 365
      this.pastDate = new Date(date.getTime() - 24 * maxDate * 3600 * 1000)

      // Get the current date and time
      let currentDate = new Date()

      if (new Date(date.getTime() + 24 * 0 * 3600 * 1000).getTime() === currentDate.getTime()) {
        this.futureEnd = new Date(date.getTime() + 24 * 0 * 3600 * 1000)
      } else {
        this.futureEnd = new Date(date.getTime() + 24 * maxDate * 3600 * 1000)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.trx-date {
  &__label {
    white-space: nowrap;
  }
  &__input {
    @include lg-screen-only {
      width: 185px !important;
    }
    @include xl-screen-only {
      width: 185px !important;
    }
  }
}
</style>
